import React, { useState } from "react";
import { BankFilled } from "@ant-design/icons";
import { Drawer, Layout, Typography } from "antd";
import Header from "./Header";
import SideNav from "./SideNav";
import { useLocation } from "react-router-dom";

const { Sider, Content } = Layout;

export default function MainLayout({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const upgraded = ["/system/users", "/bank-accounts", "/devices"].includes(useLocation().pathname);
  return (
    <Layout className={upgraded ? "upgraded-layout" : ""} style={{ minHeight: "100vh" }}>
      <Sider width={upgraded ? 210 : 250} breakpoint="lg" collapsedWidth="0" trigger={null} className="desktop-navigation app-sidebar">
        <div className="app-brand"><BankFilled /><span>{upgraded ? "BANK ADMIN" : "QUẢN LÝ NGÂN HÀNG"}</span></div>
        {upgraded && <div className="sidebar-section-label">Không gian quản lý</div>}
        <SideNav />
        <div className="app-sidebar-footer">
          <Typography.Text>{upgraded ? "Hệ thống quản trị ngân hàng" : "Ngân hàng Việt Nam"}</Typography.Text>
          <span>{upgraded ? "Không gian làm việc nội bộ" : "An toàn · Minh bạch · Phát triển"}</span>
        </div>
      </Sider>
      <Drawer width={280} placement="left" open={drawerOpen} onClose={() => setDrawerOpen(false)} bodyStyle={{ padding: 0, background: "#001529" }}>
        <SideNav onNavigate={() => setDrawerOpen(false)} />
      </Drawer>
      <Layout>
        <Header onMenuClick={() => setDrawerOpen(true)} />
        <Content className="app-content">{children}</Content>
      </Layout>
    </Layout>
  );
}
